module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-zh-hant.54c4385f006b9821875f.svg";